export const skillData = [
    {
        name: 'JavaScript',
        imgURL: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/javascript-colored.svg',
    },
    {
        name: 'React',
        imgURL: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/react-colored.svg'
    },
    {
        name: 'Css',
        imgURL: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/css3-colored.svg'
    },
    {
        name: 'Sql',
        imgURL: 'https://www.svgrepo.com/show/331760/sql-database-generic.svg'
    },
    {
        name: 'Redux',
        imgURL: 'https://cdn.worldvectorlogo.com/logos/redux.svg'
    },
    {
        name: 'Postgres',
        imgURL: 'https://cdn.worldvectorlogo.com/logos/postgresql.svg'
    },
    {
        name: 'Node.js',
        imgURL: 'https://logo-download.com/wp-content/data/images/svg/Node.js-logo.svg'
    },
    {
        name: 'Sass',
        imgURL: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Sass_Logo_Color.svg'
    },
    {
        name: 'TypeScript',
        imgURL: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg'
    },
    {
        name: 'Git',
        imgURL: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg'
    },
    {
        name: 'Angular',
        imgURL: 'https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg'
    }

]


